import {buildImageObj, cn, getBlogUrl} from "../../lib/helpers";
import styles from "./blog-post-preview.module.css";
import {imageUrlFor} from "../../lib/image-url";
import {responsiveTitle2} from "../typography.module.css";
import PortableText from "../portableText";
import {Link} from "gatsby";
import React from "react";
import * as PropTypes from 'prop-types';

export default function MediumBlogPostPreview(props) {
  return <div
    className={props.orientation === 'to-left' ? styles.mediumPreview : cn(styles.mediumPreview, styles.reversed)}
  >
    <div className={styles.mediumImg}>
      {props.mainMedia.image && props.mainMedia.image.asset && (
        <img
          className={styles.mediumImgClass}
          src={
            imageUrlFor(buildImageObj(props.mainMedia.image))
              .url()
          }
          alt={props.mainMedia.image.alt}
        />
      )}
    </div>
    <div className={styles.mediumPreviewText}>
      <h3 className={cn(responsiveTitle2, styles.title)}>{props.title}</h3>
      {props._rawExcerpt && (
        <div className={styles.excerpt}>
          <PortableText blocks={props._rawExcerpt}/>
        </div>
      )}
      <Link
        className={styles.readMoreLinkMediumPreview}
        to={getBlogUrl(props.publishedAt, props.slug.current)}
      >
        Read More
      </Link>
    </div>
  </div>
}

MediumBlogPostPreview.propTypes = {
  orientation: PropTypes.oneOf(['to-left', 'to-right']).isRequired
};